// AppLock WelcomeScreen — first-load decision: enable encryption or skip.

import { ShieldCheck, ShieldOff } from 'lucide-react';

interface WelcomeScreenProps {
  onEnable: () => void;
  onSkip: () => void;
}

export function WelcomeScreen({ onEnable, onSkip }: WelcomeScreenProps) {
  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center gap-6 p-6"
      style={{ backgroundColor: 'var(--color-bg)', color: 'var(--color-text)' }}
      data-testid="applock-welcome"
    >
      <div
        className="panel"
        style={{ maxWidth: '480px', width: '100%', textAlign: 'center' }}
      >
        <ShieldCheck size={48} aria-hidden="true" style={{ color: 'var(--color-accent)' }} />
        <h1 className="text-2xl font-bold" style={{ marginTop: 'var(--space-4)' }}>
          Protect Your Data
        </h1>
        <p
          className="text-sm"
          style={{ color: 'var(--color-text-muted)', marginTop: 'var(--space-3)' }}
        >
          Carry Roll stores your sessions, shot profiles, and bag data locally. Enable app lock to
          encrypt this data with a password. Without it, anyone with access to this device can
          read your data.
        </p>
        <p
          className="text-xs"
          style={{ color: 'var(--color-warn)', marginTop: 'var(--space-3)' }}
        >
          There is no password recovery. If you forget your password, encrypted data is
          permanently inaccessible.
        </p>

        <div
          className="flex flex-col gap-3"
          style={{ marginTop: 'var(--space-6)' }}
        >
          <button
            type="button"
            className="btn btn-primary"
            onClick={onEnable}
            data-testid="applock-enable"
          >
            <ShieldCheck size={18} aria-hidden="true" />
            Enable App Lock
          </button>
          <button
            type="button"
            className="btn"
            onClick={onSkip}
            data-testid="applock-skip"
          >
            <ShieldOff size={18} aria-hidden="true" />
            Skip for Now
          </button>
        </div>
      </div>
    </div>
  );
}
